import { LearnerListPage } from "@/features/learner/components/LearnerList";

const LearnerList = () => {
  return <LearnerListPage />;
};

export default LearnerList;
